import { passwordConfigurationValueType } from "../../types";

export const defaultPasswordConfigurationValues:passwordConfigurationValueType = {
    userLoginBlock:{
        name: "userLoginBlock",
        value: {
            "app": {
                "blockUser": false,
                "timePeriod": "",
                "numberOfAttemptsAllowed": "",
                "numberOfMinutesToBeBlocked": "",
                "unblockAfterTimePeriod": false
            },
            "portal": {
                "blockUser": false,
                "timePeriod": "",
                "numberOfAttemptsAllowed": "",
                "numberOfMinutesToBeBlocked": "",
                "unblockAfterTimePeriod": false
            }
        },
        possibleVals: [],
        description: "",
        docUrl: "",
        type: "object"
    },
    userInactivityBlock:{
        name: "userInactivityBlock",
        value: {
            "inactivityConfigDays": "",
            "designationToBlockOnInactivity": [],
        },
        possibleVals: [],
        description: "",
        docUrl: "",
        type: "object"
    }   
};
